import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import api from "@/lib/api";
import { Mail, Phone, MapPin } from "lucide-react";

export function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const cols = [
    { title: "Financing", links: [
      { label: "Loan Programs", to: "/loan-programs" },
      { label: "EMD Funding", to: "/emd-funding" },
      { label: "Transactional Funding", to: "/transactional-funding" },
      { label: "Apply for Financing", to: "/apply" },
    ]},
    { title: "Company", links: [
      { label: "About", to: "/about" },
      { label: "Capital Partners", to: "/partners" },
      { label: "Referral Program", to: "/referral-program" },
      { label: "Become a Partner", to: "/become-a-partner" },
      { label: "Contact", to: "/contact" },
    ]},
    { title: "Legal", links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Use", to: "/terms" },
      { label: "Disclosures", to: "/disclosures" },
      { label: "Sign In", to: "/login" },
    ]},
  ];

  return (
    <footer className="bg-[#07080A] border-t border-edge" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Logo size={44} showText={false} />
            <p className="mt-5 text-sm text-dim leading-relaxed max-w-sm">
              Capital for real estate investors. Financing solutions for acquisitions, rentals, renovations,
              construction, earnest money, and transactional closings.
            </p>
            <div className="mt-5 space-y-2 text-sm text-dim">
              {settings?.email && <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> {settings.email}</div>}
              {settings?.phone && <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> {settings.phone}</div>}
              {settings?.business_address && <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> {settings.business_address}</div>}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="eyebrow mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-white/70 hover:text-gold transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="hairline my-10" />

        <div className="text-xs text-faint leading-relaxed space-y-3">
          <p data-testid="footer-disclosure">{settings?.general_disclosure}</p>
          {settings?.nmls_number && <p>NMLS #{settings.nmls_number}</p>}
          {settings?.states_served && <p>{settings.states_served}</p>}
          <div className="flex flex-col sm:flex-row justify-between gap-3 pt-4 border-t border-edge/60">
            <span>© {new Date().getFullYear()} {settings?.legal_entity_name || "BullsEye Capital LLC"}. All rights reserved.</span>
            <span className="text-gold/80 tracking-[0.2em] uppercase">Execute With Precision</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
